import queryKeys from '@/constants/queryKeys';
import { subdomainInterpretationGet } from '@/services/api/requests/screener';
import { useAppStore } from '@/store/useAppStore';
import { THealthDomain, THealthSubDomain } from '@/types/Health.types';
import { useQuery } from '@tanstack/react-query';

const useSubdomainScreenerInterpretation = (domain: THealthDomain, subdomain: THealthSubDomain) => {
  const { user } = useAppStore();

  const { isLoading, data, isError, isSuccess, refetch, isRefetching } = useQuery({
    queryKey: [queryKeys.screener.subdomainInterpretation, subdomain, user?.email ?? ''],
    queryFn: async () => {
      const result = await subdomainInterpretationGet(domain.toUpperCase(), subdomain.toUpperCase());
      return result;
    },
  });

  return { isLoading, data, isError, isSuccess, refetch, isRefetching };
};

export default useSubdomainScreenerInterpretation;
